module.exports = __webpack_public_path__ + "img/cdj.0427fe20.png";